import React from "react";
import { Reveal } from "./Reveal";
import { FAQ as FAQ_DATA } from "@/data";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 bg-sf-surface/30">
      <div className="w-full max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-sf-ember" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-sf-ember">Intel · FAQ</span>
          </div>
          <h2 className="sf-stencil text-4xl md:text-5xl text-sf-bone leading-[1.05]">
            Before you deploy.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10 w-full">
            {FAQ_DATA.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid="faq-accordion-item"
                className="border-b border-sf-border"
              >
                <AccordionTrigger className="text-left sf-stencil text-lg tracking-wide text-sf-bone hover:text-sf-ember hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sf-dim text-base leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
